<template>
  <div>
    <v-dialog :persistent="true" max-width="1200px" v-model="inDialog">
      <v-card>
        <v-form ref="viewPresentForm">
          <div class="headline dialog-header">
            <v-toolbar color="primary" dark>
              <v-toolbar-title style="padding-left: 10px">{{
                $t(formName)
                }}
              </v-toolbar-title>
            </v-toolbar>
            <v-btn
                @click="onCancel"
                icon
                style="position: absolute; right: 10px; top: 10px; color: #fff"
            >
              <v-icon>cancel</v-icon>
            </v-btn>
          </div>

          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                    :data-vv-as="$t('Mã quy trình')"
                    :error-messages="errors.first('name')"
                    :label="$t('Mã quy trình')"
                    disabled
                    maxLength="250"
                    name="name"
                    type="text"
                    v-model.trim="item.code"
                    v-validate="'required'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <div style="text-align: right">
              <v-btn @click="onOpenMaterialCreateDialog" color="primary">
                <v-icon dark left>add</v-icon>
                {{ $t("lang.common.add") }}
              </v-btn>

            </div>
            <c-search-form :displayToolbar="false"
                           :fields="fields"
                           :input-create-items="createItems"
                           :input-search-items="searchItems"
                           :reload="timeReloadLocal"
                           :rows-per-page-items="[10,20,50]"
                           :search-url="searchUrl"
                           @onDeleteFromProcedure="onDeleteFromProcedure"
                           form-type="intable"
                           key-property="proMatId"
                           ref="searchTable"
                           :reset-search="resetSearch"
            />
            <div style="text-align: right">
              <v-btn @click="onCancel" color="error">
                <v-icon dark left>cancel</v-icon>
                {{ $t("lang.common.close") }}
              </v-btn>
            </div>
          </v-card-text>
          <!-- </v-container> -->
        </v-form>

      </v-card>
      <!--    <back-to-top text="Back to top"></back-to-top>-->

    </v-dialog>

  </div>
</template>

<script>
  import {message} from "../../../services";
  import axios from "axios";
  import {areaContants} from "@/constants";
  import CSearchForm from "../../../components/form/ManageForm";
  import GoTop from '@inotom/vue-go-top';

  export default {
    name: "procedure-wh-material-list",
    components: {message, axios, CSearchForm, GoTop},
    props: {
      propsItem: {
        type: Object,
        default: () => {
                    return {}
                }
      },
      cDialog: {
        type: Boolean,
        default: false,
      },
      areas: {
        type: Array,
        default: [],
      },
      rowsPerPageItems: {
        type: [Array, Number],
        default: () => [10, 20, 30, 40, 50]
      },
      timeReload: {
        type: [Number],
        default: 0
      }
    },
    data: () => {
      return {
        formName: "Danh  sách vật tư",
        areaStatus: areaContants.areaStatus,
        item: {
          code: "",
          name: "",
          status: 1,
        },
        timeReloadLocal:0,
        resetSearch: true,
        inDialog: false,
        searchItems: [],
        createItems: [],
        searchUrl: "",
        fields: [
          {
            value: "index",
            text: "lang.common.index",
            width: "5%",
            sortable: false,
            headerStyle: "text-align:center"
          },

          {
            type: "select",
            items: [],
            itemText: "categoryName",
            itemValue: "categoryId",
            name: 'typeId',
            value: 'typeId',
            text: 'lang.procedureWh.typeId',
            width: "20%",
            sortable: false,
            search: true,
            headerStyle: "text-align:left"
          },
          {
            value: "materialName",
            text: "lang.procedureWh.materialId",
            sortable: false,
            search: true,
            headerStyle: "text-align:left",
            width: "20%",
          },

          {
            value: 'custom_action',
            text: "lang.common.delete",
            icon: "delete",
            event: "onDeleteFromProcedure",
            width: "10%",
            color: "primary"
          }
        ],
      };
    },
    watch: {
      propsItem: {
        handler(value) {
          //console.log(value);
          if (value !== null) {
            this.item = Object.assign({}, value)
            this.searchUrl = "/procedureWh/material/list/" + this.item['procedureId']
            axios.get(process.env.VUE_APP_API_URL + "/procedureWh/materialTypeInProcedure/" + this.item['procedureId'], {}).then(
              data => {
                let itemFields = this.fields.filter(function (e) {
                  return e.name == "typeId";
                });
                if (itemFields != undefined && itemFields.length > 0) {
                  itemFields[0].items = data.items;
                }
              }
            )
            axios.get(process.env.VUE_APP_API_URL + "/procedureWh/materialInProcedure/" +
                this.item['procedureId'], {}).then(
              data => {
                let itemFields = this.fields.filter(function (e) {
                  return e.name == "materialId";
                });
                if (itemFields != undefined && itemFields.length > 0) {
                  itemFields[0].items = data.items;
                }
              }
            )
          } else {
            this.resetFrom();
          }
        },
        deep: true,
      },
      timeReloadLocal: {
        handler() {
          this.searchUrl = "/procedureWh/material/list/" + this.item['procedureId']
          axios.get(process.env.VUE_APP_API_URL + "/procedureWh/materialTypeInProcedure/" + this.item['procedureId'], {}).then(
            data => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "typeId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data.items;
              }
            }
          )
          axios.get(process.env.VUE_APP_API_URL + "/procedureWh/materialInProcedure/" + this.item['procedureId'], {}).then(
            data => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "materialId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data.items;
              }
            }
          )
        },
        deep: true,
      },
      cDialog(value) {
        this.inDialog = value;
        this.resetSearch = true;
      },
      inDialog(value) {
        if (!value) {
          this.$emit("closeDialog", "");
          this.resetSearch = false;
        }
      },
      timeReload(value) {
        this.timeReloadLocal = value;
      },
    },
    methods: {
      resetFrom: function () {
        this.item = {
          status: 1,
        };
      },
      onCancel: function () {
        this.$emit("closeDialog", "");
        this.searchUrl = "";
      },
      onOpenMaterialCreateDialog: function () {
        this.$emit("openMaterialCreateDialog", this.propsItem);
      },

      // onDeleteFromProcedure(item) {
      //   item['status'] = 0;
      //   axios.post(process.env.VUE_APP_API_URL + "/procedureWhMaterial/save", item).then(
      //     data => {
      //       if (data.success) {
      //         message.success(this.$t("lang.common.update_success"));
      //         this.timeReload = Math.floor(Math.random() * 100);
      //       } else {
      //         message.error(data.description);
      //       }
      //     }
      //   )
      // },
      onDeleteFromProcedure(item) {
        item['status'] = 0;
        axios.post(process.env.VUE_APP_API_URL + "/procedureWhMaterial/deleteMaterialFromProcedure", item).then(
            data => {
              if (data.success) {
                message.success(this.$t("lang.common.update_success"));
                this.timeReloadLocal = Math.floor(Math.random() * 100);
                this.$emit("deleteMaterialFromProcedure", "");
              } else {
                message.error(data.description);
              }
            }
        )
      },
      onSave: function () {
        // console.log(this.item);
        this.$validator.validate().then((valid) => {
          if (!valid) {
            message.error(this.$t("lang.common.validate_fail"));
            return;
          }
          axios
            .post(
              process.env.VUE_APP_API_URL +
              "/procedureWh/save",
              this.item
            )
            .then(
              (data) => {
                if (data.success) {
                  message.success(
                    this.$t("lang.common.save_success")
                  );
                  this.resetFrom();
                  this.onCancel();
                } else {
                  message.error(this.$t(data.description));
                }
              },
              (error) => {
                console.log(error);
              }
            );
        });
      },

    },
    created() {

    },
  };
</script>
